import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import settings from 'src/settings';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      // language cookie is managed by django
      lookupCookie: settings.VITE_APP_LANGUAGE_COOKIE_NAME || 'i18next',
      // read language from the django managed cookie and write to local storage
      order: ['cookie', 'localStorage'],
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    supportedLngs: window.languageConfig
      ? Object.keys(window.languageConfig)
      : ['en'],
    load: 'languageOnly',
    backend: {
      loadPath: `${settings.VITE_APP_API_URL}translation/i18n/{{lng}}/{{ns}}/`,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    // Prefetch translation files - fallbacks will always be loaded as well
    ns: ['common', 'login', 'survey', 'downloadManager', 'navigation'],
    // If the default ns is not set i18next-http-backend assumes a default ns 'translation'
    defaultNS: 'common',
  });

export default i18n;
